import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 32 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, delay, ease: [0.2, 0.7, 0, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionTag = ({ children }) => (
  <span
    data-testid="section-tag"
    className="inline-flex items-center gap-2 px-3 py-1 rounded bg-ops-core/60 border border-ops text-ops-light text-[10px] mono-tag uppercase tracking-[0.2em]"
  >
    {children}
  </span>
);

export const PageHero = ({ chip, title, sub, testid }) => (
  <section data-testid={testid} className="relative px-6 lg:px-12 pt-20 pb-16 border-b border-ops overflow-hidden">
    <div
      className="absolute inset-0 opacity-40 drift-ambient"
      style={{
        background:
          "radial-gradient(80% 60% at 15% 10%, rgba(46,168,223,0.14) 0%, transparent 60%), linear-gradient(145deg, #0e2038, #08101a)",
      }}
    />
    <div className="relative max-w-7xl mx-auto space-y-5">
      <SectionTag>{chip}</SectionTag>
      <h1 className="font-display text-4xl sm:text-6xl lg:text-7xl font-extrabold uppercase leading-[0.95] text-white tracking-tight">
        <span className="line-up"><span>{title}</span></span>
      </h1>
      <p className="text-base sm:text-lg text-ops-muted max-w-2xl leading-relaxed">{sub}</p>
    </div>
  </section>
);
